<div class="overlay">
  <div class="dialog">
    <img class="h5peditor-elearnio-logo" src="/assets/images/elearnio-logo-retina.png" alt="elearnio logo" />

    <div class="linear-spinner">
      <img class="spinner" src="/assets/images/spinner-v1.gif" alt="spinner" />
    </div>

    <p class="warning-message">
      {{ messageKey | translate }}
    </p>
    <button 
      class="cancel-button"
      mat-stroked-button
      color="darkblue"
      (click)="onCancelClick()"
    >
      <mat-icon>close</mat-icon>
      {{ 'common.cancel' | translate }}
    </button>
  </div>
</div>